import { Injectable, OnDestroy, AfterViewInit, OnInit, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AslibModalComponent, AslibModalService, IAslibModalOptions } from '@aslib/modal';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { ErrorService } from './error.service';
import { AslibLoadingService } from '@aslib/loading';
import { CrudService } from './crud.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AslibCommonService } from '@aslib/common';
import { AscasService } from '@ascas/core';
import { AslibAuthService } from '@aslib/security';
import { isNullOrUndefined } from 'util';
import { Observable } from 'rxjs/Observable';
import { ExportTypes } from '../shared/enum/shared.enum';
import { HttpErrorResponse } from '@angular/common/http';
import { MenssagemErroHttp } from '../shared/menssagem-erro-http';
import { DatePipe } from '@angular/common';

@Injectable()
export class BaseComponentService implements OnInit, OnDestroy {

  static nameFileCaptured = new EventEmitter<string>();
  static idFileCaptured = new EventEmitter<number>();
  public conteudo: any;
  public file: File;
  public lista: any[] = [];
  public ListContrato: any[];
  public textIncluir = `Registro incluído com sucesso.`;
  public titleIncluir = 'Inclusão';
  public textAlterar = `Registro alterado com sucesso.`;
  public titleAlterar = 'Edição';
  public textSelecione = 'Selecione..';
  public title = '';
  public titulo: string;
  public subtitle: string;
  protected subListar: Subscription;
  protected subRouter: Subscription;
  protected subRouterData: Subscription;
  public tabela: any;
  protected aslibModal: AslibModalComponent;
  protected subRota: Subscription;
  protected subSave: Subscription;
  protected tituloErro: string;
  form: FormGroup;
  edit = false;
  obj: any;
  public isGestor: boolean;
  public visible = false;
  public grupoUsuario: string;

  constructor(
    protected readonly fb: FormBuilder,
    protected readonly router: Router,
    protected readonly route: ActivatedRoute,
    protected readonly ascas: AscasService,
    protected readonly aslibService: AslibCommonService,
    protected readonly _service: CrudService,
    protected readonly errorService: ErrorService,
    protected readonly aslibLoadingService: AslibLoadingService,
    protected readonly aslibModalService: AslibModalService,
    protected _activateRoute: ActivatedRoute,
    protected _aslibAuthService: AslibAuthService,
    protected readonly datePipe: DatePipe
  ) {
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    this.aslibModal.title = 'Filtro Avançado';

    if (sessionStorage.getItem('ProjetoIntegrado') == null) {
      this.getProjetoIntegrado();
    }
  }

  ngOnInit(): void {
    this.tituloErro = 'Ocorreu um erro';
    this.subRouter = this.route.queryParams.subscribe(params => {
      if (params['Acao']) {
        const options: IAslibModalOptions = {
          title: `[${params['Acao']}] com sucesso!`,
          backdrop: 'static',
          text: `[${params['Acao']}] com sucesso!`,
          okText: 'OK',
          cancelarVisible: false,
          type: 'success'
        };
        this.aslibModal.open(options);
      }
    });

    this.subRouterData = this.route.data.subscribe(data => {
      this.tabela = data.tabela;
    });
  }

  isNumber(n: any) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  /*
  * Habilita controles do formulário.
  */
  enableFormControls(controlesForm: FormControl[]) {
    controlesForm.forEach(controle => {
      this.setStateFormControl(controle, true);
    });
  }

  /*
  * Desabilita controles do formulário.
  */
  disableFormControls(controlesForm: FormControl[]) {
    controlesForm.forEach(controle => {
      this.setStateFormControl(controle, false);
    });
  }

  /*
  * Define o estado (habilitado/desabilitado) do controle de tela informado no parâmetro.
  */
  setStateFormControl(controle: FormControl, habilitado: boolean) {
    if (habilitado) {
      controle.enable();
    }
    else {
      controle.disable();
    }
  }

  /*
  * Verifica se o FormControl informado tem valor definido.
  */
  formControlIsNull(controle: FormControl): boolean {
    return controle.value === null || controle.value === '' || controle.value === undefined;
  }

  /*
  * Limpa o conteudo dos FormControls informado na lista.
  */
  clearFormsControl(controlesForm: FormControl[]) {
    controlesForm.forEach(controle => {
      this.clearFormControl(controle);
    });
  }

  /*
  * Limpa o conteúdo do FormControl e define seu estado.
  */
  clearFormControl(controle: FormControl) {
    controle.setValue('');
  }

  /*
  * Atualiza o conteúdo do FormControl verificando a nulidade do futuro conteúdo.
  */
  updateFormControl(controle: FormControl, value: any) {
    controle.setValue(value === null || value === undefined ? '' : value);
  }

  openModal(content: any) {

    const options: {} = {
      windowClass: 'fade-show',
      headerVisible: true,
      footerVisible: false,
      backdrop: 'static',
      keyboard: false,
      size: 'xl',
    };
    const modal = this.aslibModal;
    modal.title = 'Filtro Avançado';
    modal.content = content;
    modal.open(options).result.then(
      result => {
        this.visible = !this.visible;
      },
      reason => {
        this.visible = !this.visible;
      }
    );
    this.visible = !this.visible;
    return modal;

  }

  fecharModal() {
    this.aslibModal.close('close');
    this.aslibModal.ngOnDestroy();
  }

  async getProjetoIntegrado(): Promise<any> {
    // Consulta a API para obter o projeto associado ao grupo
    this.grupoUsuario = this._aslibAuthService.loginData.DadosUsuario.Grupos[0].Descricao;
    this._service.routePrefix = `api/ControleAcessoPagamentoAutomatico/GetPorGrupo/${this.grupoUsuario}`;

    let projeto: any = 'RPV';
    try {

      // Cria a sessão do projeto integrado
      sessionStorage.removeItem("ProjetoIntegrado");
      sessionStorage.setItem("ProjetoIntegrado", projeto);

    } catch (error) {
      this.exibirErro(error);
    }
  }

  ngOnDestroy(): void {
    if (this.subListar) {
      this.subListar.unsubscribe();
    }
    if (this.subRouter) {
      this.subRouter.unsubscribe();
    }
    if (this.subRouterData) {
      this.subRouterData.unsubscribe();
    }
  }

  inicializar(entidade: any, padrao: boolean) {
    this.subRota = this.route.queryParams.subscribe(params => {
      if (params['descricao']) {
        this.edit = true;
        this.title = 'Edição';
        entidade = params;
      } else {
        this.title = 'Cadastro';
        if (padrao) {
          entidade = { id: '', descricao: '' };
        }
      }
    });
    this.form = this.fb.group({
      id: entidade.id,
      descricao: entidade.descricao,
    });

  }

  /**
   *
   * save - exceção licença
   * salvar item no banco de dados
   *
   */
  save(rota: any, dto: any, edicao: boolean, api: string) {
    this._service.routePrefix = rota;
    this.edit = edicao;
    this.aslibLoadingService.start();
    if (this.edit) {
      this.subSave = this._service.update(dto, api).subscribe(
        () => {
          this.exibirSucesso(this.textAlterar);
        },
        erro => {
          this.exibirErro(erro);
        },
        () => {
          this.aslibLoadingService.complete();
        }
      );

    } else {
      this.subSave = this._service.add(dto, api).subscribe(
        () => {
          this.exibirSucesso(this.textIncluir);
        },
        erro => {
          this.exibirErro(erro);
        },
        () => {
          this.aslibLoadingService.complete();
        }
      );
    }
  }

  getAllByFiltro(rota: any, filtro: any, api: string) {
    this._service.routePrefix = rota;

    this.aslibLoadingService.start();
    this.subSave = this._service.getAllPorFiltro(filtro, api).subscribe(
      () => {
        this.aslibLoadingService.complete();
      },
      erro => {
        this.exibirErro(erro);
      },
      () => {
        this.aslibLoadingService.complete();
      }
    );
  }

  public gerarRelatorio(filtro: any, tipoExportado: ExportTypes, api: string): Observable<Blob> {
    return this._service.report(filtro, tipoExportado, api);
  }

  saveAndDelete(rota: any, routePrefix: any, params: any, api: string) {
    this._service.routePrefix = routePrefix;
    const dto = this.form.value;

    this.aslibLoadingService.start();

    if (this.edit) {
      this._service.delete(params, api).subscribe(
        () => {
          this.subSave = this._service.add(dto, api).subscribe(
            () => {
              this.exibirSucesso(this.textIncluir);
            },
            erro => {
              this.exibirErro(erro);
            }
          );
        },
        error => {
          this.exibirErro(error);
        },
        () => {
          this.aslibLoadingService.complete();
        }
      );
    }
  }

  exibirAviso(msg: string) {
    this.showModalAlert('info', null, msg);
  }

  exibirSucesso(msg: string) {
    this.showModalAlert('success', null, msg);
  }

  exibirAlerta(msg: string) {
    this.showModalAlert('warning', null, msg);
  }

  exibirErro(erro: HttpErrorResponse) {
    const textoStatusErro = MenssagemErroHttp.getMensagem(erro.status);
    const mensagemErro = erro.status == 0 ? 'Possível falha na conexão com a WebAPI.' : erro.error.message;

    this.showModalAlert('error', `${textoStatusErro} (Código ${erro.status})`, mensagemErro);
  }

  showModalAlert(tipo: string, texto: string, conteudo: string) {
    switch (tipo) {
      case 'error': {
        this.aslibModal.type = 'error';
        this.aslibModal.title = 'Erro';
        break;
      }
      case 'success': {
        this.aslibModal.type = 'success';
        this.aslibModal.title = 'Sucesso';
        break;
      }
      case 'warning': {
        this.aslibModal.type = 'warning';
        this.aslibModal.title = 'Atenção';
        break;
      }

      case 'info': {
        this.aslibModal.type = 'info';
        this.aslibModal.title = 'Aviso';
        break;
      }
      default: {
        this.aslibModal.type = 'default';
        this.aslibModal.title = '';
        break;
      }
    }

    this.aslibModal.okVisible = true;
    this.aslibModal.okText = 'Ok';
    this.aslibModal.cancelarVisible = false;
    this.aslibModal.footerVisible = true;
    this.aslibModal.text = texto;
    this.aslibModal.content = conteudo;
    this.aslibModal.open().result.then();
  }

  showCustomModal(conteudo: any, titulo: string) {
    const options: IAslibModalOptions = {
      type: 'default',
      title: titulo,
      backdrop: 'static',
      cancelarVisible: false,
      size: 'lg',
      content: conteudo
    };

    // Carrega um modal para exibição de mansagem
    this.aslibModal.open(options).result.then(
      () => { },
      () => { }
    );
  }

  /**
   * Prepara os dados para a tela de edição
   * @param rota A rota a ser direcionado
   * @param item O objeto a ser exibido
   */
  editar(rota: string, item: any): void {
    const navigationExtras: NavigationExtras = {
      skipLocationChange: true,
      queryParams: item
    };
    this.router.navigate([`${rota}`], navigationExtras);
  }

  modalSucesso(titulo: string, texto: string) {
    this.aslibLoadingService.complete();
    this.aslibModal = null;
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
    this.aslibModal.open({ title: titulo, text: texto, type: 'success', backdrop: 'static' });
  }

  removeItem(id): void {
    this.lista = this.lista.filter(item => item !== id);
  }

  /**
 * Verifica se o sistema esta aberto
 * @param value
 */
  isOpenSystem(value: string): boolean {
    try {
      if (value.substring(0, 10) > JSON.parse(localStorage.getItem('sessDtcFechamento')).substring(0, 10)) {
        return true;
      } else {
        return false;
      }
    } catch { return true; }
  }

  /**
   * Verifica se o atributo é nulo ou indefinido
   * @param value
   */
  isNullOrUndefined(value): boolean {
    if (value === null || value === undefined) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Verifica se o atributo é nulo, indefinido ou vazio
   * @param value
   */
  isNullOrUndefinedOrEmpty(value): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    } else {
      return false;
    }
  }

  /**
   * Verifica se o atributo é vazio
   * @param value
   */
  isEmpty(value): boolean {
    if (value === '') {
      return true;
    } else {
      return false;
    }
  }

/**
* Converte data para o formato especificado
* @param data, 
* @param formato
*/
convertDate(data: Date, formato: string): string {
  return this.datePipe.transform(data, formato);
}

  /**
   * Ordena uma array de acordo com o parâmetro field
   * @param field
   */
  sortBy(field) {
    return function (a, b) {
      if (a[field] !== undefined && b[field] !== undefined) {
        if (a[field].toString().trim().toLocaleLowerCase() > b[field].toString().trim().toLocaleLowerCase()) { return 1; }
        if (a[field].toString().trim().toLocaleLowerCase() < b[field].toString().trim().toLocaleLowerCase()) { return -1; }
        return 0;
      }
    };
  }

  /**
   * Ordena uma array de acordo com os parâmetros field
   * @param field1
   * @param field2
   * @param index Índice passado como parâmetro no método substring
   */
  sortMatrizBy(field1, field2, index) {
    return function (a, b) {
      if (!isNullOrUndefined(a[field1][field2]) && !isNullOrUndefined(b[field1][field2])) {
        if (a[field1][field2].toString().trim().toLocaleLowerCase().substring(index)
          > b[field1][field2].toString().trim().toLocaleLowerCase().substring(index)) { return 1; }
        if (a[field1][field2].toString().trim().toLocaleLowerCase().substring(index)
          < b[field1][field2].toString().trim().toLocaleLowerCase().substring(index)) { return -1; }
        return 0;
      }
    };
  }

  /**
   * Preencher o comboBox
   * @param rota Url da API que irá preencher o combo
   * @param obj Objeto do combo a ser preechido
   */
  async preencheCombo(rota: string, obj: string, api: string): Promise<void> {
    try {
      this._service.routePrefix = rota;
      this[obj] = await this._service.getAll(api).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async preencheComboUmParametro(rota: string, obj: string, parametro: any, api: string): Promise<void> {
    try {
      this._service.routePrefix = rota.concat(`/${parametro}`);
      this[obj] = await this._service.getAll(api).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async preencheComboDoisParametros(rota: string, obj: string, parametro: any, parametro2: any, api: string): Promise<void> {
    try {
      this._service.routePrefix = rota.concat(`/${parametro}/${parametro2}`);
      this[obj] = await this._service.getAll(api).toPromise();
    } catch (error) {
      throw error;
    }
  }

  async preencheComboTresParametros(rota: string, obj: string, parametro: any, parametro2: any, parametro3: any, api: string): Promise<void> {
    try {
      this._service.routePrefix = rota.concat(`/${parametro}/${parametro2}/${parametro3}`);
      this[obj] = await this._service.getAll(api).toPromise();
    } catch (error) {
      throw error;
    }
  }

  monthDiff(d1, d2) {
    let months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    return months <= 0 ? 0 : months;
  }

  /**
   * Nome enviado por um componente que será capturado por outro que realizar a inscrição do "EventEmitter"
   * @param fileName
   */
  nameFileSent(fileName: string) {
    BaseComponentService.nameFileCaptured.emit(fileName);
  }

  /**
   * Id enviado por um componente que será capturado por outro que realizar a inscrição do "EventEmitter"
   * @param fileName
   */
  idFileSent(fileId: number) {
    BaseComponentService.idFileCaptured.emit(fileId);
  }

  onlyDigits(texto: string): string {
    return texto.replace(/[^\d]+/g, '');
  }

  // Se o tamanho for 11 considera como um CPF
  isCpf(value: string) {
    return this.onlyDigits(value).length === 11;
  }

  // Se o tamanho for 14 considera como um CNPJ
  isCnpj(value: string) {
    return this.onlyDigits(value).length === 14;
  }

  // Verifica se o CPF é válido
  isCpfValido(cpf: string): boolean {
    cpf = cpf.replace(/[^\d]+/g, '');

    if (cpf.length !== 11) {
      return false;
    }

    // Elimina CPFs inválidos conhecidos
    for (let i = 0; i <= 9; i++) {
      if (cpf === i.toString().repeat(11)) {
        return false;
      }
    }

    const multiplicador1 = [10, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicador2 = [11, 10, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    let resto = 0;
    let digito = '';
    let tempCpf = cpf.substring(0, 9);

    for (let i = 0; i < 9; i++) {
      soma += Number(tempCpf[i].toString()) * multiplicador1[i];
    }

    resto = soma % 11;
    if (resto < 2) {
      resto = 0;
    }
    else {
      resto = 11 - resto;
    }

    digito = resto.toString();

    tempCpf = tempCpf.concat(digito);
    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += Number(tempCpf[i].toString()) * multiplicador2[i];
    }

    resto = soma % 11;
    if (resto < 2) {
      resto = 0;
    }
    else {
      resto = 11 - resto;
    }

    digito = digito.concat(resto.toString());

    return cpf.endsWith(digito);
  }

  // Verifica se o CNPJ é válido
  isCnpjValido(cnpj: string): boolean {

    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj.length !== 14) {
      return false;
    }

    // Elimina CNPJs inválidos conhecidos
    for (let i = 0; i <= 9; i++) {
      if (cnpj === i.toString().repeat(14)) {
        return false;
      }
    }

    const multiplicador1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const multiplicador2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    let soma = 0;
    let resto = 0;
    let digito = '';
    let tempCnpj = cnpj.substring(0, 12);

    for (let i = 0; i < 12; i++) {
      soma += Number(tempCnpj[i].toString()) * multiplicador1[i];
    }

    resto = (soma % 11);
    if (resto < 2) {
      resto = 0;
    }
    else {
      resto = 11 - resto;
    }

    digito = resto.toString();

    tempCnpj = tempCnpj.concat(digito);
    soma = 0;
    for (let i = 0; i < 13; i++) {
      soma += Number(tempCnpj[i].toString()) * multiplicador2[i];
    }

    resto = (soma % 11);
    if (resto < 2) {
      resto = 0;
    }
    else {
      resto = 11 - resto;
    }

    digito = digito.concat(resto.toString());

    return cnpj.endsWith(digito);
  }

  getCnpjCpfBase(cnpjCpf: string)
  {
    return this.isCpf(cnpjCpf) ? cnpjCpf.substr(0, 9) : cnpjCpf.substr(0, 8);
  }

  getCnpjCpfFilial(cnpjCpf: string) 
  {
    return this.isCpf(cnpjCpf) ? "" : cnpjCpf.substr(8, 4);
  }

  getCnpjCpfDigito(cnpjCpf: string): number {
    return this.isCpf(cnpjCpf) ? Number(cnpjCpf.substr(9, 2)) : Number(cnpjCpf.substr(12, 2));
  }

  getCnpjCpf(base: string, filial: string, digito: number, tipo: number): string {
    if (tipo === 1) {
      // Monta o número com 11 digitos.
      return (!this.isNullOrUndefined(base) && !this.isNullOrUndefined(digito)
        ? base.padStart(9, '0') + digito.toString().padStart(2, '0') : "");
    }
    else if (tipo === 2) {
      // Monta o número com 14 digitos
      return (!this.isNullOrUndefined(base) && !this.isNullOrUndefined(filial) && !this.isNullOrUndefined(digito)
        ? base.padStart(8, '0') + filial.padStart(4, '0') + digito.toString().padStart(2, '0') : "");
    }

    return null;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/base-component.service.ts